import React from 'react';
import {Link} from "react-router-dom";

import SectionHeader from './sectionHeader.js'
import TechnologyIconAndName from './technologyIconAndName.js' 
import TechnologyVersionWithScore from './technologyVersionWithScore.js' 
import VersionRef from './versionRef.js'

import {RtHeader} from '../../../server/routes/route-types.js'
import {HydratedTechnology} from '../../../server/routes/technology-scan.js'

type Technology = HydratedTechnology;
// interface Technology {
// 	Category: string;
// 	CategoryIcon: string;
// 	CategoryURL: string;
// 	Technology: string;
// 	TechnologyURL: string;
// 	TechnologyIcon: string;
// 	Version?: string;
// 	Bucket?: number;
// 	PercentNewerVersion?: number;
// }

interface ScanDomainTechnologiesProps {
	technologies: Technology[] | null | undefined;
	link?: string;
}

export default function ScanDomainTechnologies({technologies, link}: ScanDomainTechnologiesProps) {

	if (!technologies) return null;

	const toFixBugHeader: RtHeader = {
		Title: 'Technologies',
		Subtitle: 'Subdomain Technologies'
	}

	return (
		<div className="row row-50">
			<div className="col-12">
				<SectionHeader header={toFixBugHeader} link={link} />
				<div className="table-outer table-rounded table-responsive-lg">
					<table className="table-custom table-custom-striped table-custom-primary  ">
						<thead>
							<tr>
								<th style={{width: '30%'}}>Type</th>								
								<th style={{width: '50%'}}>Technology</th>
								<th style={{width: '20%'}}>Version</th>
							</tr>
						</thead>
						<tbody>
							{
								technologies.map((technology, indexKey) =>
									<DomainTechnology technology={technology} key={indexKey}/>
								)
							}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	)
}

interface DomainTechnologyProps {
	technology: Technology;
}

function DomainTechnology({technology}: DomainTechnologyProps) {

	if (!technology) return null;
	
	return (

		<tr>			 
			<td>
				<span 
                    className={`icon text-primary mdi ${technology.CategoryIcon}`}
                ></span> 
				{' '}
				<Link 
					to={`/technology-type/${technology.CategoryURL}`}
					className="link-hover" 
					title={`${technology.Category} category market share and usage statistic`} 
				>
					{technology.Category} 
				</Link>
			</td>	
			<td>
				{' '}
				<TechnologyIconAndName 
					technology={technology.Technology}
					technologyURL={technology.TechnologyURL}
					technologyIcon={technology.TechnologyIcon}
					title={`${technology.Technology}`}
				/>
			</td>		
			<td align="left">
				{
					technology.Version && 
					<>
					<VersionRef technology={technology}/>
					{' '}
					<TechnologyVersionWithScore 
							technology={{
								TechnologyURL: technology.TechnologyURL,
								Version: technology.Version,
								Bucket: technology.Bucket || 0,
								PercentNewerVersion: technology.PercentNewerVersion || 0
							}}
							tooltip ='1'
						/>                    
					</>         
				} 
			</td>			
		
		</tr>
	)
}